import React from 'react';

import EnforcementStatusEnum from 'redpoints-model-js/enumeration/EnforcementStatusEnum';

import { Col, Field, Info } from 'redpoints-front-components/index';
import {
  LinkDataCardsAds,
  PriorityTag,
} from 'redpoints-front-common/components';

import { ROUTES } from '../../../config/constants';
import { translate } from '../../../helpers/languageHelper';

import './incidentDetailsLinkDataContentFixedData.less';

const PENDO_KEY_OUT_OF_COVERAGE =
  'FrontOffice-IncidentDetails-Tooltip-OutOfCoverage';

const AdLinks = ({ adLinks, linkType }) => {
  if (!adLinks.length) {
    return null;
  }

  return (
    <Col lg={24}>
      <Field
        className="ad-links"
        label={translate(
          'reporting.incidentDetails.linkDataContent.relatedLinks'
        )}
        rpElement="Info"
      >
        <LinkDataCardsAds
          adLinks={adLinks}
          incidentDetailRoute={ROUTES.INCIDENT_DETAILS}
          linkType={linkType}
          outOfCoveragePendoTrackId={PENDO_KEY_OUT_OF_COVERAGE}
        />
      </Field>
    </Col>
  );
};

const IncidentDetailsLinkDataContentFixedData = ({
  isAdDetectionLink,
  adLinks,
  destinationLinks,
  linkId,
  linkInfo,
  monitorData,
  priority,
}) => {
  const enforcementStatus = linkInfo?.enforcementStatus?.literalKey;
  const nonEnforceableReason = linkInfo?.reason?.name;
  const channelName =
    linkInfo?.domain?.effectiveConfiguration?.channel?.literalKey;
  const domainUrl = linkInfo?.domain?.url;
  const domainUrlLink =
    (!domainUrl?.startsWith('https') ? 'https://' : '') + domainUrl;
  const linkType = linkInfo?.linkType?.literalKey;
  const linkUrl = linkInfo?.url;

  const isStatusNotEnforcement =
    linkInfo?.enforcementStatus.name ===
    EnforcementStatusEnum.NO_ENFORCEMENT.name;

  return (
    <div className="incident-details-fixed-data-container">
      <div className="row-container">
        <Col lg={24}>
          <Info
            label={translate('reporting.incidentDetails.linkDataContent.url')}
            value={
              <a
                className="link-url"
                href={linkUrl}
                rel="noopener noreferrer"
                target="_blank"
                title={linkUrl}
              >
                {linkUrl}
              </a>
            }
          />
        </Col>
        {isAdDetectionLink ? (
          <AdLinks adLinks={destinationLinks} linkType="destinationLink" />
        ) : (
          <AdLinks adLinks={adLinks} linkType="adLink" />
        )}
        <Col lg={6}>
          <Info
            label={translate(
              'reporting.incidentDetails.linkDataContent.linkType'
            )}
            value={translate(linkType)}
          />
        </Col>
        <Col lg={6}>
          <Info
            label={translate(
              'reporting.incidentDetails.linkDataContent.linkId'
            )}
            value={linkId}
          />
        </Col>
        <Col lg={6}>
          <Info
            label={translate(
              'reporting.incidentDetails.linkDataContent.enforcementStatus'
            )}
            value={translate(enforcementStatus)}
          />
        </Col>
        {isStatusNotEnforcement && (
          <Col lg={6}>
            <Info
              label={translate(
                'reporting.incidentDetails.linkDataContent.nonEnforceableReason'
              )}
              value={nonEnforceableReason}
            />
          </Col>
        )}
        <Col lg={6}>
          <Info
            label={translate(
              'reporting.incidentDetails.linkDataContent.domainName'
            )}
            value={
              <a href={domainUrlLink} target="_blank" rel="noopener noreferrer">
                {domainUrl}
              </a>
            }
          />
        </Col>
        <Col lg={6}>
          <Info
            label={translate(
              'reporting.incidentDetails.linkDataContent.channelType'
            )}
            value={translate(`global.${channelName}`)}
          />
        </Col>
        <Col lg={6}>
          <Info
            label={translate(
              'reporting.incidentDetails.linkDataContent.monitorData.request'
            )}
            value={monitorData.lastMonitorRequest}
          />
        </Col>
        <Col lg={6}>
          <Info
            label={translate(
              'reporting.incidentDetails.linkDataContent.monitorData.response'
            )}
            value={monitorData.lastMonitorResponse}
          />
        </Col>
        <Col lg={6}>
          <PriorityTag priority={priority} />
        </Col>
      </div>
    </div>
  );
};

export default IncidentDetailsLinkDataContentFixedData;
